export default "__VITE_ASSET__BJYK5mIy__"